import React from  'react';
import ActivityComponent from '../commonComponents/ActivityComponent';
import LoadingComponent from '../commonComponents/LoadingComponent';
import axios from 'axios';
import {connect} from 'react-redux';
var base64 = require('base-64');

var bottomStyleHr = { margin: '21px 0px 12px -57px', width: '109.3%' };
var topStyle = {marginLeft: '-4px', marginTop: '21px'};

class Notification extends React.Component{
    constructor(props) {
        super(props);
        this.state = {result:props.dataSet.getNotification ? props.dataSet.getNotification : null, question:null}
        this.handleDataFormat = this.handleDataFormat.bind(this);
    }
    componentWillMount() {
        if (!this.state.result) {
            if (this.props.dataSet.siteId) {
                var userId = this.props.authData.userId;
                var authorization_value = null;
                authorization_value = "Basic " + btoa(userId + ":");
                let params = {
                    siteId: this.props.dataSet.siteId,
                    toolId: this.props.dataSet.toolId
                }
                let that = this
                CallAPI('GET', '/app/getNotifications', null, params, 0, function (response) {
                    that.setState({
                        result: response
                    })
                }, this.props.authData)
                // axios.get('/app/getNotifications',{
                //     headers: {
                //                Authorization: authorization_value
                //              },
                //      params:{
                //                 siteId:this.props.dataSet.siteId,
                //                 toolId:this.props.dataSet.toolId
                //               }
                //     }).then(res=>{
                //         this.setState({
                //                 result:res.data
                //          })
                // })   
            }
        }
    }

    // formats the result data by adding 'text' key into the json
    handleDataFormat = (data) => {
        let new_data = data.map(function(element,i) {
            let innerData = element;
            innerData['text'] = element['value'];
            return innerData;
        });
        return new_data;
    }

    render() {

        let result = null;
        let mainBody = <LoadingComponent/>
        if (this.state.result){
            result = this.handleDataFormat(Object.values(this.state.result['result']));
            mainBody = <ActivityComponent result={result} authData={this.props.authData} dataSet={this.props.dataSet} />;
        }
        return (
            <div >
                <div className='col-md-12 divSelect' >
                    <div className='row row-top padding'>
                        {mainBody}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return{
        authData: state.dataSet.authData,
        dataSet:state.dataSet.dataSet
    }
}
export default connect(mapStateToProps,null)(Notification)